export type UnsubscribeFunction = () => void;

export interface BaseDataSource<T> {
  getSnapshot: () => T;
  subscribe: (onUpdate: () => void) => UnsubscribeFunction;
}

type CallbackFunction = () => void;

export class DataSourceService<R, T extends (...args: any) => Promise<R>> {
  private snapshotMap: Record<string, R> = {};
  private subscribersMap: Record<string, Set<CallbackFunction>> = {};
  private defaultValue: R;
  private api: T;

  constructor(defaultValue: R, api: T) {
    this.api = api;
    this.defaultValue = defaultValue;
  }

  getSubscribers = (snapshotKey: string): Set<CallbackFunction> => {
    if (this.subscribersMap[snapshotKey] === undefined) {
      this.subscribersMap[snapshotKey] = new Set();
    }
    return this.subscribersMap[snapshotKey];
  };

  getDataSource = (snapshotKey: string): BaseDataSource<R> => ({
    getSnapshot: () => {
      if (this.snapshotMap[snapshotKey] === undefined) {
        this.snapshotMap[snapshotKey] = this.defaultValue;
      }
      return this.snapshotMap[snapshotKey];
    },
    subscribe: (callback: CallbackFunction) => {
      this.getSubscribers(snapshotKey).add(callback);
      return () => this.getSubscribers(snapshotKey).delete(callback);
    },
  });

  fetchAndUpdateSnapshot = (snapshotKey: string, ...payload: Parameters<T>): void => {
    this.api(...payload)
      .then((response) => {
        this.snapshotMap[snapshotKey] = response;
        this.getSubscribers(snapshotKey).forEach((callback) => {
          callback();
        });
      })
      .catch((e) => {
        console.error(`Polling failure for ${snapshotKey}: ${e}`);
      });
  };
}
